module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm2"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Also by Christopher Brookmyre")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("QUITE UGLY ONE MORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("COUNTRY OF THE BLIND")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("NOT THE END OF THE WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("ONE FINE DAY IN THE MIDDLE OF THE NIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("BOILING A FROG")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("A BIG BOY DID IT AND RAN AWAY")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("THE SACRED ART OF STEALING BE MY ENEMY")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("ALL FUN AND GAMES UNTIL SOMEBODY LOSES AN EYE")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("A TALE ETCHED IN BLOOD AND HARD BLACK PENCIL")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("ATTACK OF THE UNSINKABLE RUBBER DUCKS")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("A SNOWBALL IN HELL")])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', [_vm._v("PANDAEMONIUM")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a7bb3e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also_by.vue
// module id = 66
// module chunks = 0